import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedModule } from '@shared/module/shared.module';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { LocalRepository } from '@shared/helper/local-repository';
import { AfterViewInit, Component, Injector, OnInit, inject } from '@angular/core';
import { BaseComponent } from '@shared/components/base/base.component';
import { ShelfItemModel } from '@shared/model/customerModels/shelves-model';
import { ShelvesService } from '@app/pages/library/services/shelves.service';
import { SnackBarTypes } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';
import { MatDialogRef } from "@angular/material/dialog";
import { takeUntil } from "rxjs/operators";
import { HeaderComponent, HeaderConfigModel } from "@shared/components/header/header.component";

@Component({
    selector: 'app-new-shelf-sheet',
    templateUrl: './new-shelf-sheet.component.html',
    styleUrls: ['./new-shelf-sheet.component.scss'],
    imports: [
        SharedModule,
        HeaderComponent,
    ]
})
export class NewShelfSheetComponent extends BaseComponent implements OnInit, AfterViewInit {
  private injector = inject(Injector);
  private shelvesService = inject(ShelvesService);
  private _localRepository = inject(LocalRepository);
   

  headerConfig: HeaderConfigModel = {
    title: 'افزودن قفسۀ جدید',
    dialogHeader: true
  }

  createShelf: ShelfItemModel = new ShelfItemModel();

  private dialogRef: any = null;
  private bottomSheetRef: any = null;

  constructor() {
    super();
    this.dialogRef = this.injector.get(MatDialogRef, null);
    this.bottomSheetRef = this.injector.get(MatBottomSheetRef, null);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this._localRepository.IsInBrowser)
      this._localRepository.getDocument.getElementById('shelfTitle')?.focus();
  }

  createNewShelf() {
    if (!this._localRepository.IsInBrowser) return;

    this.createShelf.descriptions = "";
    this.shelvesService.createNewShelf(this.createShelf)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        if (res.hasError || !res.result) return;
        this.createShelf.id = res.result;

        this._localRepository.IsInMobile ? this.bottomSheetRef.dismiss(this.createShelf) : this.dialogRef.close(this.createShelf);

        this.snackbarService.openSnackbar(SnackBarTypes.success, `قفسۀ «${this.createShelf.title}» با موفقیت اضافه شد.` );
      });
  }

  close() {
    this._localRepository.IsInMobile ? this.bottomSheetRef.dismiss() : this.dialogRef.close();
  }
}
